import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewRef } from '@angular/core';
import { ConfirmationDialogService } from 'src/app/common/component/confirmation-dialog/confirmation-dialog.service';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OTPService } from './service/otp.service';
import { Router } from '@angular/router';
import { Title } from "@angular/platform-browser";
import * as moment from 'moment';
declare var CollectJS: any;


@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.css'],
  providers: [Location, { provide: LocationStrategy, useClass: PathLocationStrategy }]
})


export class OTPComponent implements OnInit {

  billerBranding: any;
  cardErr: any;
  collectJSFields: any;
  colorHex: any;
  colorComplementary: any;
  confirmationComplete: boolean;
  contact: any;
  externalId: any;
  isLoading: boolean;
  isSubmitted: boolean;
  logoUrl: any;
  payloadData: any;
  paymentData: any;
  paymentDate: any;
  paymentId: any;
  paymentMethod: any;
  paymentToken: any;
  refreshIntervalId: any;
  receiptResponse: any;
  response: any;
  termsAndConditions: any;
  totalAmount: any;
  type: string;
  validUSphoneNumber: boolean;
  submittedButtonPressed: boolean;

  private isCollectJsPresent: boolean = false;


  constructor(private ref: ChangeDetectorRef, private confirmationDialogService: ConfirmationDialogService, private elementRef: ElementRef, private location: Location, private modalService: NgbModal, private otpService: OTPService, private router: Router, private titleService: Title) {

    this.cardErr = {
      checkname: {
        flag: false,
        msg: ""
      },
      ccnumber: {
        flag: false,
        msg: ""
      },
      ccexp: {
        flag: false,
        msg: ""
      },
      cvv: {
        flag: false,
        msg: ""
      }
    };
    this.colorComplementary = null;
    this.confirmationComplete = false;
    this.contact = {
      email: "",
      phoneNumber: ""
    }
    this.isLoading = false;
    this.isSubmitted = false;
    this.otpService = otpService;
    this.payloadData = undefined;
    this.paymentData = {
      paymentDate: {
        year: parseInt(moment(new Date()).format("YYYY")),
        month: parseInt(moment(new Date()).format("MM")),
        day: parseInt(moment(new Date()).format("DD"))
      },
      tokenId: null,
      paymentType: "",
      name: "",
      card: "",
      cardExp: "",
      zipCode: "",
      agree: null
    };
    this.paymentDate = "";
    this.paymentMethod = null;
    this.receiptResponse = null;
    this.refreshIntervalId = "";
    this.response = {};
    this.titleService.setTitle("Payment Hub - Powered by Etactics");
    this.type = "paymentPage";
    this.submittedButtonPressed = false;
  }


  ngOnInit(): void {
    localStorage.clear();
    let q = this.router.parseUrl(this.router.url);
    if ('q' in q.queryParams && q.queryParams.q) {
      console.log(q.queryParams.q);
      this.loadPayloadData(q.queryParams.q);
    }
  }

  loadPayloadData(externalId: any) {
    this.otpService.getPayloadData(externalId).subscribe(res => {
      if (res.status != 200) {
        console.log(res);
        alert(res.body);
        return;
      }
      this.payloadData = res.body;


      if (this.payloadData.colorHex == null || this.payloadData.colorHex == '') {
        this.colorHex = '#8a8a8a';
      } else {
        this.colorHex = this.payloadData.colorHex;
      }
      
      this.setBackgroundToColorBase();
      this.calculateComplementaryColor(this.colorHex);
      this.externalId = externalId;
      this.termsAndConditions = this.payloadData.billerBranding.find(x => x.dbId == "6").text;

      this.loadCollectJSScript(this.payloadData.jsAPIkey);
    }, err => {
      console.log(err)
      alert(err.error.message)
    });
  }

  setBackgroundToColorBase() {
      this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = this.colorHex;
  }

  calculateComplementaryColor(hex: any) {
	  // validate hex string
	  hex = String(hex).replace(/[^0-9a-f]/gi, '');
	  if (hex.length < 6) {
		    hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
	  }

	  // convert to decimal and change luminosity
	  var rgb = "#", c, i;
	  for (i = 0; i < 3; i++) {
		    c = parseInt(hex.substr(i*2,2), 16);
		    c = Math.round(Math.min(Math.max(0, c + (c * 1.33)), 255)).toString(16);
		rgb += ("00"+c).substr(c.length);
	  }
    this.colorComplementary = rgb;
  }

  private collectJsCss: string = '{"border-width": "0px","text-align": "center","padding-left": "5px","color": "#454545"}';

  loadCollectJSScript(apiKey: string) {
    return new Promise((resolve, reject) => {
      if (!this.isCollectJsPresent) {
        // load script
        const script: any = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://secure.networkmerchants.com/token/Collect.js';
        script.setAttribute('data-tokenization-key', apiKey);
        script.setAttribute('data-custom-css', JSON.stringify(this.collectJsCss));
        if (script.readyState) {  // IE
          script.onreadystatechange = () => {
            if (script.readyState === 'loaded' || script.readyState === 'complete') {
              script.onreadystatechange = null;
              this.isCollectJsPresent = true;
              resolve({ script: name, loaded: true, status: 'Loaded' });
              this.spinUpJSFields();
            }
          };
        } else {  // Others
          script.onload = () => {
            this.isCollectJsPresent = true;
            resolve({ script: name, loaded: true, status: 'Loaded' });
            this.spinUpJSFields();
          };
        }
        script.onerror = (error: any) => resolve({ script: name, loaded: false, status: 'Loaded' });
        document.getElementsByTagName('head')[0].appendChild(script);
      } else {
        resolve({ script: name, loaded: true, status: 'Already Loaded' });
        this.spinUpJSFields();
      }
    });
  }


  spinUpJSFields() {
    this.collectJSFields = {
      checkname: {
        placeholder: 'Name on Card',
        selector: '#ccName'
      },
      ccnumber: {
        placeholder: 'Credit/Debit Card Number',
        selector: '#ccNumber'
      },
      ccexp: {
        placeholder: 'Exp. MM/YY',
        selector: '#ccExp'
      },
      cvv: {
        placeholder: 'CVV',
        selector: '#cvv'
      },
      googlePay: {
        buttonType: 'plain',
        buttonColor: 'black',
        billingAddressRequired: true
      },
      applePay: {
        type: 'plain',
        style: {
          height: '40px'
        }
      }
    }
    this.ref.detectChanges();
    this.loadCollectJS();
  }

  detectChanges() {
    this.refreshIntervalId = setInterval(() => {
      if (this.ref && !(this.ref as ViewRef).destroyed) {
        this.ref.detectChanges();
      }
    }, 1000);
  }

  public loadCollectJS() {
    this.detectChanges();

    CollectJS.configure({
      paymentSelector: "#demoPayButton",
      variant: 'inline',
      country: 'US',
      price: String(this.payloadData.amountDue),
      currency: 'USD',
      validationCallback: (field, status, message) => {
        if (status) {
          this.cardErr[field] = {
            flag: false,
            msg: ""
          };
        } else {
          this.cardErr[field] = {
            flag: true,
            msg: message
          };
        }
        console.log(this.cardErr);
        this.ref.detectChanges();
      },
      timeoutDuration: 10000,
      timeoutCallback: () => {
        this.disableLoadingImage();
        console.log("The tokenization didn't respond in the expected timeframe.  This could be due to an invalid or incomplete field or poor connectivity");
      },
      fieldsAvailableCallback: () => {
        console.log("Collect.js loaded the fields onto the form");
      },
      callback: (response) => {
        this.displayLoadingImage();
        this.isSubmitted = true;
        this.finishSubmit(response);
      },
      fields: this.collectJSFields
    });

    CollectJS.startPaymentRequest();
    this.ref.detectChanges();
  }

  public getPaymentDate() {
    return moment(new Date(this.paymentData.paymentDate.year, this.paymentData.paymentDate.month - 1, this.paymentData.paymentDate.day)).format("MM/DD/YYYY");
  }

  showTermsAndConditions(longContent) {
    this.modalService.open(longContent, { scrollable: true, animation: true });
  }

  finishSubmit(response: any) {
    console.log(response);
    this.paymentData.tokenId = response.token;
    this.paymentData.name = response.check.name;
    let card = {
      cardNumber: response.card.number,
      cardExp: response.card.exp
    };
    this.paymentData.card = card;
    
    if (response.tokenType == 'applePay') {
      this.paymentMethod = 'Apple Pay';
      this.paymentData.paymentType = 'applepay';
      if (this.paymentData.name === null ) {
        this.paymentData.name = '';
      }
      if (this.paymentData.card.cardNumber === null) {
        this.paymentData.card.cardNumber = '';
      }
      if (  this.paymentData.card.cardExp === null) {
        this.paymentData.card.cardExp = '';
      }
      if (this.paymentData.zipCode === null) {
        this.paymentData.zipCode = '';
      }
    } else if (response.tokenType == 'googlePay') {
      this.paymentMethod = 'Google Pay';
      this.paymentData.paymentType = 'googlepay';
    } else {
      this.paymentMethod = 'Card - ' + response.card.number;
      this.paymentData.paymentType = 'card';
    }

    this.ref.detectChanges();
    this.doPayment();
  }

  public displayLoadingImage() {
    this.isLoading = true;
    this.ref.detectChanges();
  }

  public disableLoadingImage() {
    this.isLoading = false;
    this.ref.detectChanges();
  }

  doPayment() {
    this.paymentData.pmtDate = moment(new Date(this.paymentData.paymentDate.year, this.paymentData.paymentDate.month - 1, this.paymentData.paymentDate.day)).format("YYYY-MM-DD");

    let postData = {
      "paymentDate": this.paymentData.pmtDate,
      "tokenId": this.paymentData.tokenId,
      "paymentType": this.paymentData.paymentType,
      "name": this.paymentData.name,
      "card": this.paymentData.card.cardNumber,
      "cardExp": this.paymentData.card.cardExp,
      "zipCode": this.paymentData.zipCode
    };

    this.otpService.makePayment(this.externalId, postData).subscribe(
      res => {
        if (res.status != 200) {
          alert(res.body);
        }
        let data = res.body;
        res.body.submittedDate = moment(data.submittedAt).format('MM/DD/YYYY');
        res.body.submittedTime = moment(data.submittedAt).format('h:mma') + ' EST';
        this.response = res.body;
        this.toggleScreen('confirmationPage');
        this.disableLoadingImage();
      }, err => {
        console.log(err)
        alert(err.error.message)
      }
    );
  }

  toggleScreen(type: any) {
    this.type = type;
    this.ref.detectChanges();
  }

  public isValidUSphoneNumber(phoneNumber: any) {
    let regexp = new RegExp('^\\([0-9]{3}\\) [0-9]{3}-[0-9]{4}$');
    let plainPhoneNumberRegexp = new RegExp('^[0-9]{10}$');
    //if empty then consider it to be a valid state
    if (phoneNumber.length === 0) {
      this.validUSphoneNumber = true;
    } else {
      this.validUSphoneNumber = regexp.test(phoneNumber) || plainPhoneNumberRegexp.test(phoneNumber);
    }

    return this.validUSphoneNumber;
  }

  doReceipt() {
    this.displayLoadingImage();
    this.contact.phoneNumber = this.contact.phoneNumber.replace(/\D/g, '');

    let postData = {
      "email": this.contact.email,
      "phoneNumber": this.contact.phoneNumber
    };

    this.otpService.getReceipt(this.response.nmiTransactionId, postData).subscribe(
      res => {
        if (res.status != 200) {
          alert(res.body);
        }
        this.receiptResponse = res.body;
        this.confirmationComplete = true;
      }, err => {
        console.log(err)
        alert(err.error.message)
      }
    );
  }
}
